import api from './api';
import types from './mutation-types';

export default {
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		//{key : key, value : value}
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	getPopupParts_({ commit, state }) {
		const { searchParams, pagingInfo } = state;
		return api
			.getPopupParts({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					// 기존 정상 처리
					const { pagingInfo, resultList } = data.body;
					commit(types.PART_LIST, data !== null && data !== undefined ? resultList : null);
					commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
